import React from 'react';
import MemberDashboard from '../member/MemberDashboard';

// External Dashboard uses the same component as Member Dashboard
// The component internally checks isMember to show/hide features
const ExternalDashboard = () => {
  return <MemberDashboard />;
};

export default ExternalDashboard;
